import { getTime, getUnixTime } from 'date-fns'

export const UNIX_NOW = getUnixTime(getTime(new Date()))

export const DAYS_IN_YEAR = 365
export const DAYS_IN_100_YEARS = DAYS_IN_YEAR * 100
